import { useLocation, useNavigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import { PATH_PAGE } from '../../routes/paths';
import { useSelector } from '../../redux/store';

const useResourceAccess = () => {
  const { env, isResource, user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { contractWithAvailabilityAccess } = useSelector((state) => state.resources);

  const isResourceWithoutActiveContract = isResource && !user?.hasOneContractActive;

  const {
    settings: {
      is_mission_enabled: isMissionEnabled,
      res_access_availabilities: resAccessAvailabilities,
      res_access_demands: resAccessDemands,
      res_access_schedule: resAccessSchedule
    }
  } = env;

  const {
    resource: { availabilities, demands: resourceDemands, missions, schedule }
  } = PATH_PAGE;

  // * Resource - redirections

  // Une ressource sans contrat actif a accès uniquement à la page Missions
  if (isResourceWithoutActiveContract && !pathname.includes(missions)) {
    return navigate(missions);
  }

  // * Resource

  if (
    isResource &&
    ((!resAccessSchedule && pathname.includes(schedule)) || // Planning
      (!resAccessDemands && pathname.includes(resourceDemands)) || // Demandes
      ((!resAccessAvailabilities || !user.hasOneContractActive || !contractWithAvailabilityAccess.length) &&
        pathname.includes(availabilities)) || // Gestion des disponibilités
      (!isMissionEnabled && pathname.includes(missions))) // Missions
  ) {
    return false;
  }

  return true;
};

export default useResourceAccess;
